import { Box, SxProps, Theme, Stack, TextField, Card, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/system';


type GenericStyledProps = {
  sx?: SxProps,
  children?: JSX.Element | string | undefined,
  direction?: string
};


const useSecurePortalStackStyles = makeStyles((theme: Theme) => ({
  stack: {
    [theme.breakpoints.down('xl')]: {
      maxWidth: '60%',
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: '40%',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '90%',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
    '& .borderErrorClass': {
      border: '1px solid red !important'
    },
    '& .textErrorClass': {
      color: 'red'
    }
  },
}));

const FileUploadLabelWrapper = styled(Box)(() =>({
  fontWeight: 400,
  fontSize: '16px',
  fontFamily: 'Schibsted Grotesk',
  lineHeight: '20px',
  color: '#181818',
}));


const FileCloseWrapper = styled(Box)(() => ({
  backgroundColor: 'rgba(254, 37, 37, 0.08)',
  borderRadius: '4px',
  width: '22px',
  height: '22px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));


const TextFieldWrapper = styled(TextField)(({ height }: { height?: string }) => ({
  '& .MuiInputBase-root': {
    height: typeof height != 'undefined' ? height : '48px',
  },
}));

const UploadButtonWrapper = styled(Button)(() => ({
  display: 'flex',
  flexDirection: 'row',
  fontFamily: 'Schibsted Grotesk',
  fontSize: '16px',
  fontWeight: 400,
  color: '#262626',
  textTransform: 'none',
  border: '1px solid #D6D6D6',
  lineHeight: '20px',
  '&:hover': {
    border: '1px solid #D6D6D6',
  },
}));

const CardWrapper = styled(Card)(() => ({
  boxShadow: 'none',
  width: '100%',
  borderRadius: '6px 6px 6px 6px',
  mt: '30px', 
  border: '1px solid #D6D6D6',
  background: 'transparent',
}));

const LabelWrapper = styled(Box)(() => ({
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '22.5px',
  color: '#181818',
}));

const SubmitButtonWrapper = styled(Button)(({ label }: { label?: string }) => ({
  width: '141px',
  height: '44px',
  lineHeight: '44px',
  fontFamily: 'Schibsted Grotesk',
  fontWeight: 500,
  fontSize: '16px',
  textAlign: 'center',
  marginRight: '12px',
  color: '#181818',
  borderRadius: '100px',
  border: `1px solid ${ label == 'submit' ? 'linear-gradient(90deg, rgba(0,206,207,1) 0%, rgba(36,73,252,1) 35%, rgba(36,73,252,1) 100%)' : '#878787'}`,
  '&:hover': {
    border: `1px solid ${ label == 'submit' ? 'linear-gradient(90deg, rgba(0,206,207,1) 0%, rgba(36,73,252,1) 35%, rgba(36,73,252,1) 100%)' : '#878787'}`,        
  },
}));

const GradientWrapper = styled(Box)(() => ({
  height: '60px',
  background: 'linear-gradient(90deg, rgba(36,73,252,1) 0%, rgba(36,73,252,1) 35%, rgba(0,206,207,1) 100%)',
}));


const GenericBox = styled(Box)(() => ({
  fontFamily: 'Schibsted Grotesk',
  fontWeight: 500,
  fontSize: '24px',
  lineHeight: '30px',
  color: '#181818',
}));

const SecurePortalStack = ({ sx, children }: GenericStyledProps) => {

  const classes = useSecurePortalStackStyles();
  return (<Stack className={classes.stack} sx={{ mt: '30px', ...sx }}>{children}</Stack>);
};

export {
  SecurePortalStack,
  GradientWrapper,
  GenericBox,
  LabelWrapper,
  TextFieldWrapper,
  CardWrapper,
  UploadButtonWrapper,
  SubmitButtonWrapper,
  FileCloseWrapper,
  FileUploadLabelWrapper,
};